import { useEffect, useRef, useState } from 'react';
import { useRouterActions } from '@atlassian/react-resource-router';

export const useNavigationBlockModal = ({
	shouldModalBeShown,
}: {
	shouldModalBeShown: boolean;
}) => {
	const { registerBlock } = useRouterActions();
	const promiseInfo = useRef<{
		resolve: (shouldResolve: boolean) => void;
	}>({
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		resolve: () => {},
	});

	const [isModalOpen, setIsModalOpen] = useState(false);

	useEffect(() => {
		const unregister = registerBlock(() => {
			if (shouldModalBeShown) {
				return new Promise((resolve) => {
					promiseInfo.current = {
						resolve,
					};
					setIsModalOpen(true);
				});
			}
			return true;
		});

		return () => {
			unregister();
		};
	}, [registerBlock, shouldModalBeShown]);

	const closeModal = () => {
		setIsModalOpen(false);
		promiseInfo.current.resolve(true);
	};

	return { isModalOpen, closeModal };
};
